import React from 'react';
import { summitContent } from '../rich-content/summit-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const SummitDetailPage = () => {
  return <AutomaticPageBuilder content={summitContent} />;
};

export default SummitDetailPage;
